import React from 'react';
import { func, string } from 'prop-types';
import styles from './RightSideButtons.module.scss';

const onMouseDown = (event) => {
  event.stopPropagation();
};

const AboutButton = ({ onClick, label }) => (
  <button
    type="button"
    onClick={onClick}
    onMouseDown={onMouseDown}
    className={styles.buttonLarge}
  >
    <h4 className={styles.label}>{label}</h4>
  </button>
);

AboutButton.propTypes = {
  onClick: func.isRequired,
  label: string.isRequired,
};

export default AboutButton;
